import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, Grid, Card, CardContent, CardMedia, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { fetchCategories } from '../../services/api';
import { Category } from '../../types';

const Home: React.FC = () => {
    const navigate = useNavigate();
    const [categories, setCategories] = useState<Category[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadCategories = async () => {
            try {
                const data = await fetchCategories();
                setCategories(data);
            } catch (err) {
                setError(err instanceof Error ? err.message : 'Une erreur est survenue');
            } finally {
                setLoading(false);
            }
        };

        loadCategories();
    }, []);

    const getImageUrl = (category: Category) => {
        if (!category.imageUrl) {
            return '/uploads/products/logo.svg';
        }
        return category.imageUrl;
    };

    if (loading) {
        return (
            <Container>
                <Typography variant="h6">Chargement...</Typography>
            </Container>
        );
    }

    if (error) {
        return (
            <Container>
                <Typography variant="h6" color="error">
                    Erreur: {error}
                </Typography>
            </Container>
        );
    }

    return (
        <Container>
            <Box sx={{ my: 1, textAlign: 'center' }}>
                <Typography variant="h5" gutterBottom>
                    Découvrez nos activités
                </Typography>
            </Box>

            <Grid container spacing={4}>
                {categories.map((category) => (
                    <Grid item key={category._id} xs={12} sm={6} md={4}>
                        <Card
                            onClick={() => navigate(`/category/${category.slug}`)}
                            sx={{
                                cursor: 'pointer',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                '&:hover': {
                                    transform: 'scale(1.02)',
                                    transition: 'transform 0.2s ease-in-out',
                                },
                            }}
                        >
                            <CardMedia
                                component="img"
                                height="250"
                                image={getImageUrl(category)}
                                alt={category.name}
                                onError={(e) => {
                                    e.currentTarget.src = '/uploads/products/logo.svg';
                                }}
                            />
                            <CardContent sx={{ flexGrow: 1 }}>
                                <Typography gutterBottom variant="h6" component="h2">
                                    {category.name}
                                </Typography>
                                <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                                    {category.description}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default Home;